import * as http from '~/utils/apis';

const cardMetaData = {
    getAll: async () => {
        const { data } = await http.get(`cms-api/card-metadata`);
        return data;
    },
};

export default cardMetaData;
